import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Modal from '../../../UniformComponents/Modal'
import Input from '../../form/Input'
import Button from '../../../UniformComponents/Button'
import Typography from '../../../UniformComponents/Typography'

@observer
class DashboardRename extends Component {
    constructor(props) {
        super(props)

        const { dashStore } = props
        const { dashboard } = dashStore

        this.state = {
            name: dashboard.name,
        }
    }

    render() {
        const {
            show, onClose, dashStore,
        } = this.props
        const { name } = this.state
        const { saveDashboard } = dashStore

        return (
            <Modal show={show} onClose={onClose}>
                <div className="uc-modal__header">
                    <Typography type="h2">{i18n.t('dashboard.modal.rename.title')}</Typography>
                </div>
                <div style={{ marginBlock: '24px' }}>
                    <Input
                        label={i18n.t('dashboard.modal.clone.label')}
                        value={name}
                        onChange={({ value }) => { this.setState({ name: value }) }}
                    />
                </div>
                <div className="uc-modal__button-panel">
                    <Button
                        label={i18n.t('cancel')}
                        cssClass="tertiary"
                        onClick={onClose}
                    />
                    <Button
                        label={i18n.t('save')}
                        cssClass="primary"
                        onClick={() => {
                            saveDashboard(false, name)
                            onClose()
                        }}
                    />
                </div>
            </Modal>
        )
    }
}

export default DashboardRename
